// extracted by mini-css-extract-plugin
export default {"wrap":"gG-z","articleImagesWrap":"hG-z","articleImage":"iG-z","singleImage":"jG-z"};